import { update } from 'ramda';
import { onFormChange, makeAllFieldsDirty, highlightErrors } from '../../../actions/form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { Constraint, ControlInterface, FieldJson, FormJson } from 'edocatbase/Form';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Form from '../../App/App';
import { validateForm } from '../../../lib/validation';
import prepareFormForSubmit from '../../../lib/prepareFormForSubmit';
import Button from '../../../../Button';
import { toggleModal } from '../../../../ModalTest/actions';
import Modal from '../../../../ModalTest';
const INNER_FORM_INSTANCE_ID = 'tableForm';

interface FormModalProps extends ReduxComponentInterface, ControlInterface {
	params: any;
	formModal: any;
	formInstanceId: string;
	fields: { [key: string]: FieldJson };
	constraints: Constraint[];
}

interface FormModalState {
	formData: FormJson;
}

class FormModal extends React.PureComponent<FormModalProps, FormModalState> {
	static defaultProps = {
		value: [],
	};

	constructor(props: FormModalProps) {
		super(props);

		const {
			params,
			formModal: { items },
		} = props;

		const formData = {
			...params.formJson,
			hideSubmitButtons: true,
			mode: 'edit',
		};

		const fields = Object.keys(formData.fields);

		fields.forEach(key => {
			const field = formData.fields[key];
			if (!items?.isNew) {
				formData.fields[key].value = items?.data?.[key] ?? '';
			} else {
				formData.fields[key].value = '';
			}

			if (field.label === null || field.label === "") {
				formData.fields[key].label = `${field.id} (${field.dataType})`;
			}
		});

		const firstFieldName = formData.structure[0].children[0].id;

		formData.fields[firstFieldName].autoFocus = true;

		this.state = {
			formData,
		};
	}

	validate() {
		const { actions, fields, constraints, formInstanceId } = this.props;

		const validation = validateForm(fields, constraints);
		actions.makeAllFieldsDirty(formInstanceId, INNER_FORM_INSTANCE_ID);
		actions.highlightErrors(formInstanceId, validation.validationErrors, INNER_FORM_INSTANCE_ID);

		return validation;
	}

	submit = () => {
		const { fields } = this.props;

		const { hasErrors } = this.validate();
		if (!hasErrors) {
			return prepareFormForSubmit(fields, undefined, undefined, undefined, undefined, true, true);
		}

		return null;
	};

	onModalClose = (event?: React.MouseEvent) => {
		event && event.preventDefault();
		const { actions, name, formInstanceId } = this.props;
		actions.toggleModal(false, `form${name}`, null, formInstanceId);
	};

	onNewSave = (event: React.FormEvent) => {
		event.preventDefault();
		const { actions, name, value, formInstanceId } = this.props;
		const data = this.submit();

		if (data) {
			actions.onFormChange(formInstanceId, [name], [...value, data]);
			actions.toggleModal(false, `form${name}`, null, formInstanceId);
		}
	};

	onEditSave = (event: React.FormEvent) => {
		event.preventDefault();
		const {
			actions,
			value,
			name,
			formModal: {
				items: { index },
			},
			formInstanceId,
		} = this.props;
		const data = this.submit();

		if (data) {
			actions.onFormChange(formInstanceId, [name], update(index, data, value));
			actions.toggleModal(false, `form${name}`, null, formInstanceId);
		}
	};

	render() {
		const { formModal, formInstanceId, name } = this.props;

		return (
			<Modal
				name={`form${name}`}
				title={
					formModal?.items?.isNew
						? window.Alfresco.messages.global['button.add']
						: window.Alfresco.messages.global['button.edit']
				}
				hideActionButtons
				reducerPath={[formInstanceId, 'formModal']}
				className="tableFormModal"
				formOnly={true}
				fullWidth={true}
				maxWidth={'md'}
			>
				<div className="modal-body">
					<Form
						formJson={this.state.formData}
						display={true}
						formInstanceId={formInstanceId}
						innerFormInstanceId={INNER_FORM_INSTANCE_ID}
					/>
				</div>
				<div className="modal-actions">
					<Button
						primary
						label={window.Alfresco.messages.global['button.ok']}
						onClick={formModal?.items?.isNew ? this.onNewSave : this.onEditSave}
					/>
					<Button label={window.Alfresco.messages.global['button.close']} onClick={this.onModalClose} />
				</div>
			</Modal>
		);
	}
}

const mapStateToProps = (state: any, props: any) => ({
	fields: state[props.formInstanceId]?.form?.[INNER_FORM_INSTANCE_ID]?.fields || {},
	constraints: state[props.formInstanceId]?.form?.[INNER_FORM_INSTANCE_ID]?.constraints || {},
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ toggleModal, onFormChange, makeAllFieldsDirty, highlightErrors }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormModal);
